import { ItemIdModel } from "../filter-model/item-id-model";
import { FilterViewModel } from "../regulation";
import { StatusModel } from "./impact-status-model";
import { AdditionalFilter } from '../rulebook/additional-filter';
import { MasterHelper } from "../../utilities";

export class ImpactAssessmentT5 {

    //Summary Details
    id: number;
    updatedDB_Id: number; //Assessment Id
    isMerged: boolean;
    merged_Id: string;
    updatedDB_Date: Date; //Date
    geography: string;
    mappingID: string;
    country: string;
    regulator: string;
    pubType: string; //Type
    title: string; //Title
    description: string;
    hyperlink: string;
    jurisdiction: string;
    lastUpdatedTime: Date;
    previousImpactAsss_Id: string;
    assessmentStatus:string;
    createdDateTime: Date;

    //Assessment Details
    team: string;
    responseLead: string;
    accountableExecutive: string;
    ruleType: string;
    ruleTopic: string;
    ragRating: string;
    resposeDeadline: Date | null;
    effectiveDate: Date | null;
    consultationPeriod: string;
    didWeRespond: boolean;
    responseAppraoch: string;
    responseSubmissionDate: Date | null;
    extensionRequested: boolean;
    currentStatus: string;
    nextActionDate: Date | null;
    nextActionStep: string;

    policyReformSummery: string;
    responseKeyMessages: string;
    externalStakeHolderPositions: string;
    internalStakeholdersPacks: string;
    engagementPlan: string;
    engagementPlanDetails: string;
    policyResponseAchieved: string;
    numberofKeyMessages: number;
    keyMessagesAcheived: number;
    detail: string;

    userId: string;
    userName: string;
    jurisdictionId: number;
    isSendNotification: boolean;
    versionNumber: number;
    assessmentStatusId:number;
    isRecordTime:boolean;
    timeSpent:number;
    templateNo:number;

    constructor() {
        this.id = 0;
        this.updatedDB_Id = 0;
        this.geography = "";
        this.mappingID = "";
        this.isMerged = false;
        this.merged_Id = "";
        this.previousImpactAsss_Id = "";
        this.updatedDB_Date = new Date();
        this.country = "";
        this.regulator = "";
        this.pubType = "";
        this.title = "";
        this.description = "";
        this.hyperlink = "";
        this.jurisdiction = "";
        this.team = "";
        this.responseLead = "";
        this.accountableExecutive = "";
        this.ruleType = "";
        this.ruleTopic = "";
        this.ragRating = "";
        this.resposeDeadline = null;
        this.effectiveDate = null;
        this.consultationPeriod = "";
        this.didWeRespond = false;
        this.responseAppraoch = "";
        this.responseSubmissionDate = null;
        this.extensionRequested = false;
        this.currentStatus = "";
        this.nextActionDate = null;
        this.nextActionStep = "";
        this.policyReformSummery = "";
        this.responseKeyMessages = "";
        this.externalStakeHolderPositions = "";
        this.internalStakeholdersPacks = "";
        this.engagementPlan = "";
        this.engagementPlanDetails = "";
        this.policyResponseAchieved = "";
        this.numberofKeyMessages = 0;
        this.keyMessagesAcheived = 0;
        this.detail = "";
        this.userId = "";
        this.userName = "";
        this.jurisdictionId = 0;
        this.isSendNotification = false;
        this.versionNumber = 0;
        this.lastUpdatedTime = new Date();
        this.assessmentStatus = "";
        this.assessmentStatusId = 0;
        this.isRecordTime = false;
        this.timeSpent = 0;
        this.templateNo = 5;
        this.createdDateTime = new Date();
    }
}

export class ImpactAssessmentT5DetailListModel {
    policyReformSummery: Array<ItemDetailList>;
    responseKeyMessages: Array<ItemDetailList>;
    externalStakeHolderPositions: Array<ItemDetailList>;
    internalStakeholdersPacks: Array<ItemDetailList>;
    engagementPlanDetails: Array<ItemDetailList>;
    detail: Array<ItemDetailList>;

    constructor() {
        this.policyReformSummery = [];
        this.responseKeyMessages = [];
        this.externalStakeHolderPositions = [];
        this.internalStakeholdersPacks = [];
        this.engagementPlanDetails = [];
        this.detail = [];
    }
}
export class ItemDetailList {
    itemTitle: string;
    createdOn: Date;

    constructor() {
        this.itemTitle = '';
        this.createdOn = new Date();
    }
}

export class ImpactAssessmentT5DropDownList {
    team: StatusModel[];
    ruleType: StatusModel[];
    ragRating: StatusModel[];
    consultationPeriod: StatusModel[];
    responseApproach: StatusModel[];
    currentStatus: StatusModel[];
    templateno: number;
    engagementPlan: StatusModel[];
    policyResponseAchieved: StatusModel[];

    constructor() {
        this.team = [];
        this.ragRating = [];
        this.currentStatus = [];
        this.consultationPeriod = [];
        this.ruleType = [];
        this.responseApproach = [];
        this.templateno = 0;
        this.engagementPlan = [];
        this.policyResponseAchieved = [];
    }
}

export class ImpactAssessmentT5DetailsDD {
    jurisdiction: Array<ItemIdModel>;
    ruleTopics: Array<FilterViewModel>;
    pubType: Array<string>;
    accountableExecutive: Array<FilterViewModel>;
    responseLead: Array<FilterViewModel>;

    constructor() {
        this.jurisdiction = [];
        this.pubType = [];
        this.ruleTopics = [];
        this.accountableExecutive = [];
        this.responseLead = [];
    }
}

export class UpdateImpactAssessmentT5Model {
    impactAssessment: ImpactAssessmentT5;

    constructor() {
        this.impactAssessment = new ImpactAssessmentT5();
    }
}

export class RagRating {
    color: string;
    itemTitle: string;
    constructor() {
        this.color = '';
        this.itemTitle = '';
    }
}

export class ImpactAssessmentT5Filter extends AdditionalFilter {
    filterType: string;
    fromDate: string | null;
    toDate: string | null;
    //New Field
    team: string[];
    namedPersonnel: string[];
    ruleType: string[];
    ragRating: string[];
    responseApproach: string[];
    currentStatus: string[];
    jurisdiction: string[];
    engagementplan: string[];
    policyResponseAchieved: string[];
    updatesDBId?: number[] = [];
    pageSize: number;
    page: number;

    constructor() {
        super();
        this.filterType = '';
        this.fromDate = null;
        this.toDate = null;
        this.team = [];
        this.namedPersonnel = [];
        this.ruleType = [];
        this.ragRating = [];
        this.responseApproach = [];
        this.currentStatus = [];
        this.engagementplan = [];
        this.jurisdiction = [];
        this.policyResponseAchieved = [];
        this.updatesDBId = [];
        this.pageSize = 30;
        this.page = 1;
    }
}

export class ImpactAssessmentT5MasterFilter {
    fromDate: Date;
    toDate: Date;
    team: FilterViewModel[];
    namedPersonnel: FilterViewModel[];
    ruleType: FilterViewModel[];
    ragRating: FilterViewModel[];
    responseApproach: FilterViewModel[];
    currentStatus: FilterViewModel[];
    jurisdiction: FilterViewModel[];
    engagementplan: FilterViewModel[];
    policyResponseAchieved: FilterViewModel[];

    constructor() {
        this.fromDate = MasterHelper.getDate(30);
        this.toDate = MasterHelper.getDate(0);
        this.team = [];
        this.namedPersonnel = [];
        this.ruleType = [];
        this.ragRating = [];
        this.responseApproach = [];
        this.currentStatus = [];
        this.engagementplan = [];
        this.jurisdiction = [];
        this.policyResponseAchieved = [];
    }
}

export class ImpactAssessmentT5ViewModel {
    data: ImpactAssessmentT5[];
    totalCount: number;
    templateNo!: number;

    constructor() {
        this.data = [];
        this.totalCount = 0;
    }
}

export class ImpactAssessmentT5ColumnModel {
    id: boolean;
    regulator: boolean;
    title: boolean;
    jurisdiction: boolean;
    team: boolean;
    responseLead: boolean;
    accountableExecutive: boolean;
    ruleType: boolean;
    ruleTopic: boolean;
    rAGRating: boolean;
    resposeDeadline: boolean;
    effectiveDate: boolean;
    consultationPeriod: boolean;
    didWeRespond: boolean;
    responseAppraoch: boolean;
    reportSubmissionDate: boolean;
    extensionRequested: boolean;
    currentStatus: boolean;
    nextActionDate: boolean;
    nextActionStep: boolean;
    engagementPlan: boolean;
    policyResponseAchieved: boolean;
    numberofKeyMessages: boolean;
    keyMessagesAcheived: boolean;


    constructor() {
        this.id = true;
        this.regulator = true;
        this.title = true;
        this.ruleTopic = true;
        this.ruleType = true;
        this.team = true;
        this.responseLead = true;
        this.jurisdiction = true;
        this.accountableExecutive = true;
        this.rAGRating = true;
        this.resposeDeadline = true;
        this.effectiveDate = true;
        this.consultationPeriod = true;
        this.didWeRespond = true;
        this.responseAppraoch = true;
        this.reportSubmissionDate = true;
        this.extensionRequested = true;
        this.currentStatus = true;
        this.nextActionDate = true;
        this.nextActionStep = true;
        this.engagementPlan = true;
        this.policyResponseAchieved = true;
        this.numberofKeyMessages = true;
        this.keyMessagesAcheived = true;
    }
}

export class BulkUpdateT5Model {
    itemIds: Array<number>;
    impactAssessment: ImpactAssessmentT5;
  
    constructor() {
      this.itemIds = [];
      this.impactAssessment = new ImpactAssessmentT5();
    }
  }
  export class RegulationStatusInfoT5Model {
    id: number;
    regulationStatus: string;
    closedType: string;
    jurisdiction: string;
    userId: string;
    userName: string;
    linkedIds: string;
    type:string;
    merged_Id:string;
    mergedId:number;
    comment:string;
    templateNo:number;
  
    constructor() {
      this.id = 0;
      this.regulationStatus = '';
      this.closedType = '';
      this.jurisdiction = '';
      this.userId = '';
      this.userName = '';
      this.linkedIds = '';
      this.type = '';
      this.merged_Id = '';
      this.mergedId = 0;
      this.comment = "";
      this.templateNo = 0;
    }
  }